/* Defines the group for each state, used to differentiate by the generic reducer to decide which slice of state is invoking the reducer action */
/* Alphabetical sorting here PLEASE */

export const GROUP_BILLING_INVOICE = 'invoice';
export const GROUP_BILLING_USER = 'user';

export const GROUP_CONTRACTORS = 'contractors';
export const GROUP_CONTRACTOR_PAYMENTS = 'contractorPayment';
export const GROUP_CONTRACTOR_DOCUMENTS = 'contractorDocument';

export const GROUP_EMPLOYEES = 'employees';
export const GROUP_EMPLOYEE_SUGGESTIONS = 'suggestions';
export const GROUP_EMPLOYEE_PAYSTUBS = 'employeePaystub';
export const GROUP_EMPLOYEE_DOCUMENTS = 'employeeDocument';
export const GROUP_EMPLOYEE_BENEFITS = 'employeeBenefit';
export const GROUP_EMPLOYEE_DEDUCTIONS = 'employeeDeduction';
export const GROUP_EMPLOYEE_WAGES = 'employeeWage';

export const GROUP_PAYROLL = 'payroll';
export const GROUP_PAYROLL_HISTORY = 'payrollHistory';

export const GROUP_LOCATION = 'location';
export const GROUP_LOCATION_RULES = 'locationRules';

export const GROUP_SETTINGS_LEAVE_POLICIES = 'leavePolicy';

export const GROUP_TAXATION = 'taxation';
export const GROUP_TAXATION_DOCUMENTS = 'documents';
export const GROUP_TAXATION_DEPOSITS = 'deposits';

export const GROUP_WORKPLACE = 'workplace';
